// Configurations/graphql.js
export default function getGraphQLConfig() {
  switch (window.location.hostname) {
    case "www.uat.portal.rcshealth.io":
    case "uat.portal.rcshealth.io":
      // case "localhost":
      // return {
      //   endpoint: "https://nydpfmpuurfi3b4k4wo4j7cete.appsync-api.us-east-1.amazonaws.com/graphql",
      //   region: "us-east-1",
      //   defaultAuthMode: "userPool",
      // };
        return {
        endpoint: "https://lm52ae2jovfb7ja73rztz27usu.appsync-api.us-east-1.amazonaws.com/graphql",
        region: "us-east-1",
        defaultAuthMode: "userPool",
      };


    case "www.dev.portal.rcshealth.io":
    case "dev.portal.rcshealth.io":
        // case "localhost":
      // return {
      //   endpoint: "https://fnyt5tamkrb6xclvgl7mp55ilu.appsync-api.us-east-1.amazonaws.com/graphql",
      //   region: "us-east-1",
      //   defaultAuthMode: "userPool",
      // };
       return {
        endpoint: "https://vfpuzaihqjdwnazhzbdzc4zn7i.appsync-api.us-east-1.amazonaws.com/graphql",
        region: "us-east-1",
        defaultAuthMode: "userPool",
      };

    case "www.portal.rcshealth.io":
    case "portal.rcshealth.io":
    case "localhost":
      return {
        endpoint: "https://gvvpwlfu2vda7n7k3i2wvwxnt4.appsync-api.us-east-1.amazonaws.com/graphql",
        region: "us-east-1",
        defaultAuthMode: "userPool",
      };
    default:
      return {
        endpoint: "https://fnyt5tamkrb6xclvgl7mp55ilu.appsync-api.us-east-1.amazonaws.com/graphql",
        region: "us-east-1",
        defaultAuthMode: "userPool",
      };
  }
}
